import { useEffect } from 'react';
import { useDrag } from 'react-dnd';

import type {
  Dashboard2DnDColumnItemT,
  MappedChartColumn,
} from '@/features/Dashboard/types/types';

type Props = {
  index: number;
  rowIndex: number;
  rowId: string;
  column: MappedChartColumn;
  setSomeDragging: (someDragging: boolean) => void;
};

const useDashboardCardDrag = (props: Props) => {
  const { index, rowIndex, setSomeDragging, column, rowId } = props;
  const [{ isDragging }, dragRef, previewRef] = useDrag<
    Dashboard2DnDColumnItemT,
    unknown,
    { isDragging: boolean }
  >(
    () => ({
      type: String(column.type),
      item: { column: column, rowIndex, rowId },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
      end: (_, monitor) => {
        const didDrop = monitor.didDrop();
        if (!didDrop) {
          //didDrop이 !(아니다)라는 것은 dropRef로 선언한 태그위에 드랍되지 않음 을 의미한다.
          //그때는 원래의 위치대로 이동.
        }
      },
    }),
    [column, index],
  );

  useEffect(() => {
    isDragging ? setSomeDragging(true) : setSomeDragging(false);
  }, [isDragging, setSomeDragging]);

  return {
    dragRef,
    previewRef,
    isDragging,
  };
};

export default useDashboardCardDrag;
